export const API_HOST = 'http://localhost:3000/api/v1';
export const WS_URI = 'ws://localhost:3000/cable';
export const TUS_URI = 'http://localhost:9292/files';
